import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { APP_SETTINGS } from '@services';
import { cloneList } from 'src/app/shared/utils/utils';
import { AuthService } from '../../../core/services/auth/auth.service';
import { SpinnerService } from '../../../core/services/spinner/spinner.service';
import { UtilityService } from '../../../core/services/utility/utility.service';
import { VideosService } from '../videos.service';
import { NgIf, NgFor, NgStyle } from '@angular/common';
import { RouterLink } from '@angular/router';
@Component({
    selector: 'app-videos-manage-subscription',
    templateUrl: './videos-manage-subscription.component.html',
    styleUrls: ['./videos-manage-subscription.component.css'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [NgIf, NgFor, NgStyle, RouterLink]
})
export class VideosManageSubscriptionComponent implements OnInit {

  public videosSubscriptionList;
  public videosSubscriptionList_copy;
  public screenWidth;
  APP_SETTINGS:any;
  username: string;

  constructor(
    private videoService: VideosService,
    private utilityService: UtilityService,
    private changeDetector: ChangeDetectorRef,
    private authService: AuthService,
    private spinnerService: SpinnerService
  ) {
    this.screenWidth = this.utilityService.getScreenWidth();
  }

  ngOnInit() {
    this.username = this.authService.getUserName();
    this.APP_SETTINGS = APP_SETTINGS;
    this.spinnerService.show('bmwSpinner');
    this.videoService.getSubscribedChannels(this.username).subscribe(data => {
      this.spinnerService.hide('bmwSpinner');
      this.videosSubscriptionList = data;
      this.videosSubscriptionList_copy = cloneList(this.videosSubscriptionList);
    });
  }

  getSubscribedChannels() {
    // get subscribe channels api data
    this.videoService.getSubscribedChannels(this.username).subscribe(value => {
      this.videosSubscriptionList_copy = value;
    });
  }
  isChannelSubscribed(channelNumber): boolean {
    if (this.videosSubscriptionList_copy) {
      return this.videosSubscriptionList_copy.some(channel => channel.channelNumber === channelNumber);
    }
    return false;
  }
  toggleChannelSubsciprtion(channelNumber) {
    this.videoService.toggleSubscribeChannel(this.username, channelNumber).subscribe(data => {
      this.videosSubscriptionList_copy = data;
    });
  }
  applySubscriptionChanges() {
    this.utilityService.publishChannelSubscription(true);
  }

}
